import React from "react";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function ShapeOfYou() {
  return (
    <>
      <HeaderWithSearch />
      <main style={{
        minHeight: "100vh",
        width: "100%",
        background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
        padding: 0,
        margin: 0
      }}>
        <section style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
          padding: "60px 0 40px 0"
        }}>
          <h1 style={{ fontSize: "3rem", fontWeight: "bold", marginBottom: 12 }}>Shape of You</h1>
          <p style={{ fontSize: "1.3rem", color: "#333", marginBottom: 32 }}>A fun and rhythmic piano cover of Ed Sheeran's global hit.</p>
          <div style={{ width: 340, height: 191, marginBottom: 24, borderRadius: 24, overflow: "hidden", boxShadow: "0 4px 32px rgba(0,0,0,0.10)" }}>
            <iframe
              width="340"
              height="191"
              src="https://www.youtube.com/embed/JGwWNGJdvx8"
              title="Shape of You Piano Cover"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{ borderRadius: 24, width: "100%", height: "100%" }}
            ></iframe>
          </div>
          <div style={{ fontSize: "1.1rem", color: "#555", maxWidth: 600, textAlign: "center" }}>
            "Shape of You" is a chart-topping pop song, reimagined for piano. Watch the video above!
          </div>
        </section>
        {/* About this song section */}
        <section style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: 48,
          padding: "40px 0 0 0",
          maxWidth: 1200,
          margin: "0 auto"
        }}>
          <div style={{ flex: 1, minWidth: 320 }}>
            <h2 style={{ fontSize: "2rem", fontWeight: 600, marginBottom: 16, color: "#1a3a5d" }}>About this song</h2>
            <p style={{ fontSize: "1.1rem", color: "#444", lineHeight: 1.7 }}>
              "Shape of You" was released in 2017 by Ed Sheeran and became one of the best-selling digital singles of all time. Its catchy melody and rhythmic groove make it a favorite for piano covers and performances.
            </p>
            <ul style={{ fontSize: "1.05rem", color: "#555", marginTop: 18, marginLeft: 18 }}>
              <li>Released: 2017</li>
              <li>Album: ÷ (Divide)</li>
              <li>Genre: Pop</li>
              <li>Charted: #1 in 34 countries</li>
            </ul>
          </div>
        </section>
        {/* Fun facts / fill space visually */}
        <section style={{
          marginTop: 64,
          background: "rgba(255,255,255,0.7)",
          borderRadius: 32,
          maxWidth: 1100,
          marginLeft: "auto",
          marginRight: "auto",
          padding: "36px 32px 32px 32px",
          boxShadow: "0 2px 24px rgba(30,60,120,0.07)",
          display: "flex",
          flexDirection: "row",
          gap: 48,
          alignItems: "center",
          justifyContent: "center"
        }}>
          <div style={{ flex: 1, minWidth: 260 }}>
            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, color: "#1a3a5d", marginBottom: 10 }}>Did you know?</h3>
            <ul style={{ color: "#444", fontSize: "1.05rem", lineHeight: 1.7, marginLeft: 18 }}>
              <li>"Shape of You" is one of the most-streamed songs on Spotify.</li>
              <li>The song won the Grammy Award for Best Pop Solo Performance in 2018.</li>
              <li>Its marimba-inspired riff is instantly recognizable.</li>
            </ul>
          </div>
          <div style={{ flex: 1, minWidth: 260, textAlign: "center" }}>
            <ImageWithFallback src="/profile.png" alt="Artist" style={{ width: 120, borderRadius: "50%", marginBottom: 12, boxShadow: "0 2px 12px rgba(0,0,0,0.10)" }} />
            <div style={{ color: "#1976d2", fontWeight: 500, fontSize: "1.1rem" }}>Explore more piano covers on this site!</div>
          </div>
        </section>
        {/* Try Another Song / Request a Song section */}
        <section style={{
          background: "rgba(255,255,255,0.8)",
          borderRadius: 32,
          maxWidth: 900,
          margin: "48px auto 0 auto",
          padding: "40px 32px 32px 32px",
          boxShadow: "0 2px 24px rgba(30,60,120,0.07)",
          display: "flex",
          flexDirection: "row",
          gap: 48,
          alignItems: "flex-start",
          justifyContent: "center"
        }}>
          <div style={{ flex: 1, minWidth: 260 }}>
            <h2 style={{ fontSize: "2rem", fontWeight: 600, color: "#1a3a5d", marginBottom: 18 }}>Try Another Song</h2>
            <ul style={{ color: "#444", fontSize: "1.1rem", lineHeight: 1.7, marginLeft: 18, marginBottom: 0 }}>
              <li><a href="/Senorita" style={{ color: "#1976d2", textDecoration: "none" }}>Senorita</a> (Shawn Mendes & Camila Cabello)</li>
              <li><a href="/LetMeDownSlowly" style={{ color: "#1976d2", textDecoration: "none" }}>Let Me Down Slowly</a> (Alec Benjamin)</li>
              <li><a href="/jee-le-zara" style={{ color: "#1976d2", textDecoration: "none" }}>Jee Le Zara</a> (Bollywood)</li>
            </ul>
          </div>
          <div style={{ flex: 1, minWidth: 260, textAlign: "center" }}>
            <h2 style={{ fontSize: "2rem", fontWeight: 600, color: "#1a3a5d", marginBottom: 18 }}>Request a Song</h2>
            <p style={{ color: "#444", fontSize: "1.1rem", lineHeight: 1.7 }}>
              Want to see your favorite song covered? <a href="mailto:your@email.com" style={{ color: "#1976d2", textDecoration: "underline" }}>Email me your request!</a>
            </p>
          </div>
        </section>
        <div style={{
            fontSize: "1.1rem",
            color: "#555",
            maxWidth: 600,
            textAlign: "center",
            marginTop: 24
          }}>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/bG0lPiP49Sk"
              title="Shape of You Piano Cover"
              frameBorder="0"
              style={{ border: "none", display: "block", margin: "0 auto" }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
      </main>
    </>
  );
}

export default ShapeOfYou;
